<template>
  <div class="fullHeigthPage">
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-card-title>
        <h5 class="card-title">Consultar</h5>
      </b-card-title>

      <div class="row">
        <b-form-group
          label="Referência"
          invalid-feedback="campo obrigatório"
          class="col-md-2"
          :state="state('referencia')"
        >
          <date-picker
            v-model="dados.referencia"
            type="month"
            value-type="MM/YYYY"
            format="MM/YYYY"
            placeholder="Mês/Ano"
          ></date-picker>
        </b-form-group>
        <b-form-group
          label="Contrato Serviço"
          invalid-feedback="campo obrigatório"
          class="col-md-4"
          :state="state('contrato')"
        >
          <multiselect
            v-model="dados.contrato"
            placeholder="Selecione"
            :show-labels="false"
            :options="optionContrato"
            label="nome"
            :allow-empty="false"
            @input="inputContrato"
          />
        </b-form-group>

        <b-form-group
          label="Projeto"
          invalid-feedback="campo obrigatório"
          class="col-md-6"
          :state="state('projeto')"
        >
          <multiselect
            v-model="dados.projeto"
            placeholder="Selecione"
            :show-labels="false"
            :options="optionProjeto"
            label="nome"
            :allow-empty="false"
            @input="inputProjeto"
            style="positon: absolute"
          />
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group
          label="Cooperado"
          invalid-feedback="campo obrigatório"
          class="col-md-6"
          :state="state('cooperado')"
        >
          <multiselect
            v-model="dados.cooperado"
            placeholder="Selecione"
            :show-labels="false"
            :options="optionCooperado"
            label="nome"
            :allow-empty="true"
          />
        </b-form-group>
        <b-form-group class="mt-3 col-md-6">
          <div class="d-flex justify-content-end">
            <div class="me-2 align-self-center mt-1">
              <b-button variant="primary" @click="filtrar()" class="m-1">
                <i
                  class="mdi mdi-filter-outline font-size-16 align-middle me-2"
                ></i>
                Filtrar
              </b-button>
            </div>
            <div div class="me-2 align-self-center mt-1">
              <b-button @click="limpar()">
                <i class="mdi mdi-broom font-size-16 align-middle me-2"></i>
                Limpar
              </b-button>
            </div>
          </div>
        </b-form-group>
      </div>
    </b-card>

    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
    </div>

    <div class="row">
      <div class="col-md-4">
        <!-- Informações do cooperado -->
        <div class="card heightCardHeader" v-if="viewInfoCoop">
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-md-4">
                <img
                  :src="
                    dadosInfoCoop.fotoCoop
                      ? dadosInfoCoop.fotoCoop
                      : require('@/assets/images/user.png')
                  "
                  alt
                  class="avatar-lg rounded-circle img-thumbnail"
                />
              </div>
              <div class="flex-grow-1 p-3 col-xxl-6">
                <h5 class="font-size-15">{{ dadosInfoCoop.coopNome }}</h5>
                <h6 class="font-size-13">{{ dadosInfoCoop.coopProfissao }}</h6>
                <p class="text-muted mb-0">{{ dadosInfoCoop.coopCargo }}</p>
              </div>
            </div>
            <div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Idade</th>
                      <td>{{ dadosInfoCoop.idade }} Anos</td>
                    </tr>
                    <tr>
                      <th scope="row">Tempo de CNH</th>
                      <td>{{ dadosInfoCoop.tempo_cnh }} Anos</td>
                    </tr>
                    <tr>
                      <th scope="row">Contrato</th>
                      <td>{{ dadosInfoCoop.contrato }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Projeto</th>
                      <td>{{ dadosInfoCoop.projeto }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Sede</th>
                      <td>{{ dadosInfoCoop.sede }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Período</th>
                      <td>{{ dadosInfoCoop.periodo }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="card heightCardHeader" v-if="viewGuageChart">
          <div class="card-body">
            <div class="row">
              <h4 class="card-title text-center">Informações do RDV</h4>

              <div class="col-md-7 apexMargin">
                <apexchart
                  class="apex-charts"
                  type="radialBar"
                  :series="radialChart.series"
                  :options="radialChart.chartOptions"
                ></apexchart>
                <div class="d-flex">
                  <div class="table-responsive col-md-4 m-auto">
                    <table class="table text-center">
                      <thead class="table-info">
                        <tr>
                          <th>Despesas</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {{
                              this.$tools.converteReal(
                                parseFloat(dadosGaugeChart.despesas)
                              )
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    class="table-responsive col-lg-4 col-md-5 col-sm-12 m-auto"
                  >
                    <table class="table text-center">
                      <thead class="table-info">
                        <tr>
                          <th>Limite</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {{
                              this.$tools.converteReal(
                                parseFloat(dadosGaugeChart.limite)
                              )
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row col-lg-5 col-md-12 flex-responsive m-auto">
                <div class="table-responsive col-lg-6 col-md-12 p-1">
                  <table class="table mb-0 text-center">
                    <thead class="table-info">
                      <tr>
                        <th>Nº RDV</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ dadosGaugeChart.cd_rdv }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="table-responsive col-lg-6 col-md-12 p-1">
                  <table class="table mb-0 text-center">
                    <thead class="table-info">
                      <tr>
                        <th>Status RDV</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ dadosGaugeChart.status_rdv }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="table-responsive col-lg-6 col-md-12 p-1">
                  <table class="table mb-0 text-center">
                    <thead class="table-info">
                      <tr>
                        <th>Referência</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ dadosGaugeChart.dt_referencia }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="table-responsive col-lg-6 col-md-12 p-1">
                  <table class="table mb-0 text-center">
                    <thead class="table-info">
                      <tr>
                        <th>Período</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {{ dadosGaugeChart.dt_inicio.substr(0, 10) }} A
                          {{ dadosGaugeChart.dt_fim.substr(0, 10) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <!-- grafico de pizza -->
        <div class="card" v-if="viewPieChart">
          <div class="card-body">
            <b-tabs pills justified content-class="p-3 text-muted">
              <b-tab active class="border-0 custom-border">
                <template v-slot:title>
                  <span>Gráfico de Total por Despesa</span>
                </template>
                <apexchart
                  class="apex-charts"
                  height="500"
                  type="pie"
                  :series="graficoDespesa.series"
                  :options="graficoDespesa.chartOptions"
                ></apexchart>
              </b-tab>

              <b-tab class="border-0 custom-border">
                <template v-slot:title>
                  <span>Gráfico de Total por Categoria</span>
                </template>
                <apexchart
                  class="apex-charts"
                  height="500"
                  type="pie"
                  :series="graficoCategoria.series"
                  :options="graficoCategoria.chartOptions"
                ></apexchart>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <!-- Aprimora -->
        <b-card v-if="viewAprimora">
          <b-card-title>
            <div class="d-flex justify-content-between">
              <h5 class="card-title">Aprimora - Atividades Técnicas</h5>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="syncTelemetria"
                  v-model="syncTelemetria"
                  :disabled="disabledSyncTelemetria"
                  @change="sincronizaAprimoraTelemetria"
                />
                <label class="form-check-label" for="syncTelemetria"
                  >Temeletria</label
                >
              </div>
            </div>
          </b-card-title>
          <div class="table-responsive col-md-12 font-size-12 m-auto">
            <b-table
              responsive="sm"
              :items="tabelaAprimora"
              :fields="camposAprimora"
              per-page="5"
              :current-page="currentPageAprimora"
              @row-clicked="emitirRelatorioAprimora"
              tbody-tr-class="div-clickable"
              hover
            >
              <template v-slot:cell(dtconclusao)="data">
                {{ $tools.converteData(data.value.substr(0, 10)) }}
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="dataTables_paginate paging_simple_numbers">
              <ul class="pagination pagination-rounded mb-0 float-end">
                <b-pagination
                  v-model="currentPageAprimora"
                  :total-rows="rowsAprimora"
                  per-page="5"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-8">
        <div class="table-responsive card" v-if="viewTabelaDespesas">
          <b-table
            responsive="sm"
            :items="despesas"
            :fields="campos"
            :filter="filtro"
            :per-page="perPage"
            :current-page="currentPage"
            @row-clicked="abrirModal"
            tbody-tr-class="div-clickable"
            hover
          >
            <template v-slot:cell(icone)="data">
              <div>
                <span
                  class="material-icons m-1 rounded-circle text-center badge"
                  :style="'background-color: ' + data.item.ds_cor_web"
                  style="color: #fff; font-size: 18px"
                >
                  <i :class="'mdi ' + data.item.ds_icone_web"></i>
                </span>
              </div>
            </template>
            <template v-slot:cell(ds_st_lancamento)="data">
              <span
                class="badge badge-pill font-size-12"
                :class="{
                  'badge-soft-primary':
                    data.item.ds_st_lancamento === 'Liberado',
                  'badge-soft-danger':
                    data.item.ds_st_lancamento === 'Rejeitado',
                  'badge-soft-danger':
                    data.item.ds_st_lancamento === 'Pré-rejeitado',
                  'badge-soft-warning':
                    data.item.ds_st_lancamento === 'Pendente',
                  'badge-soft-info':
                    data.item.ds_st_lancamento === 'Pré-aprovado',
                  'badge-soft-success':
                    data.item.ds_st_lancamento === 'Aprovado',
                }"
              >
                {{ data.item.ds_st_lancamento }}
              </span>
            </template>
          </b-table>

          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  class="p-2"
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- mapa -->
    <!-- <b-card no-body>
          <b-card-body class="pb-0">
            <b-card-title>
              <h5 class="card-title">Telemetria do Veículo</h5>
            </b-card-title>

            <div id="map" style="height: 600px"></div>

            <div v-if="viewTelemetria">

              <div class="row" v-if="diaMapa">
                <div class="div-clickable col-md-6 mt-4">
                  <div class="bg-info bg-soft text-center p-3">
                    <h5 class="font-size-14 mb-0">Data</h5>
                  </div>
                  <div class="text-center p-1 border">
                    <h4>{{diaMapa}}</h4>
                  </div>
                </div>
                <div class="div-clickable col-md-6 mt-4">
                  <div class="bg-info bg-soft text-center p-3">
                    <h5 class="font-size-14 mb-0">Trajeto/dia (KM)</h5>
                  </div>
                  <div class="text-center p-1 border">
                    <h4>{{(kmDiario / 1000).toFixed(1)}}</h4>
                  </div>
                </div>
              </div>

              <div class="table-responsive col-md-12 font-size-12 m-auto">
                <b-table
                  responsive="sm"
                  :items="tabelaTelemetria"
                  :fields="camposTelemetria"
                  per-page="5"
                  :current-page="currentPageTelemetria"
                  @row-clicked="montarMapaDirecoes"
                  tbody-tr-class="div-clickable"
                  hover
                >
                <template #head(excesso)="scope">
                  <div class="talkbubble-bottom" v-if="tooltipTable.ex" style="top:60%">
                    Excesso de Velocidade<br>
                    Critérios:<br>
                    Entre 120 e 129 KM/H – De 00:00:00 a 23:59:59
                  </div>
                  <span class="badge badge-pill font-size-12 badge-soft-warning"
                        @mouseover="tooltipTable.ex = true" 
                        @mouseout="tooltipTable.ex = false">
                    {{ scope.label }}
                  </span>
                </template>
                <template #head(foraHorario)="scope">
                  <div class="talkbubble-bottom" v-if="tooltipTable.fh" style="top:60%">
                    Fora do Horário<br>
                    Critérios:<br>
                    Domingo – De 00:00:00 a 23:59:59<br>
                    Segunda-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                    Terça-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                    Quarta-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                    Quinta-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                    Sexta-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                    Sábado - Vespertino/Noturno– De 14:00:00 a 23:59:59<br>
                  </div>
                  <span class="badge badge-pill font-size-12 badge-soft-secondary" 
                        @mouseover="tooltipTable.fh = true" 
                        @mouseout="tooltipTable.fh = false">
                    {{ scope.label }}
                  </span>
                </template>
                <template #head(madrugada)="scope">
                  <div class="talkbubble-bottom" v-if="tooltipTable.ma" style="top:60%">
                    Uso na Madrugada<br>
                    Critérios:<br>
                    Segunda-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                    Terça-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                    Quarta-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                    Quinta-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                    Sexta-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                    Sábado – Madrugada – De 00:00:00 a 04:59:59<br>
                  </div>
                  <span class="badge badge-pill font-size-12 badge-soft-primary" 
                        @mouseover="tooltipTable.ma = true" 
                        @mouseout="tooltipTable.ma = false">
                    {{ scope.label }}
                  </span>
                </template>
                <template #head(risco)="scope">
                  <div class="talkbubble-bottom" v-if="tooltipTable.ri" style="top:60%">
                    Conducao de Risco<br>
                    Critérios:<br>
                    Acima de 130 KM/H – De 00:00:00 a 23:59:59
                  </div>
                  <span class="badge badge-pill font-size-12 badge-soft-danger"
                        @mouseover="tooltipTable.ri = true" 
                        @mouseout="tooltipTable.ri = false">
                    {{ scope.label }}
                  </span>
                </template>
                <template #head(informativo)="scope">
                  <span class="badge bg-light text-dark font-size-12" 
                        data-tooltip="Informativo" 
                        data-tooltip-location="left">
                    {{ scope.label }}
                  </span>
                </template>
                <template #cell(data)="data">
                  {{data.value}} - {{$tools.diaSemanaAbrev(data.item.dt_gps.getDay())}}
                </template>
                </b-table>
              </div>

              <div class="row">
                <div class="dataTables_paginate paging_simple_numbers ">
                  <ul class="pagination pagination-rounded mb-0 float-end">
                    <b-pagination
                      v-model="currentPageTelemetria"
                      :total-rows="rowsTelemetria"
                      per-page="5"
                    ></b-pagination>
                  </ul>
                </div>
              </div>

              <div class="row">
                <div class="div-clickable col-md-6 m-auto mt-4">
                  <div class="bg-info bg-soft text-center p-3">
                    <h5 class="font-size-14 mb-0">Excesso de Velocidade</h5>
                  </div>
                  <div class="text-center p-1 border">
                    <h4>{{dadosOcorrencia.excesso}}</h4>
                  </div>
                </div>

                <div class="div-clickable col-md-6 m-auto mt-4">
                  <div class="bg-info bg-soft text-center p-3">
                    <h5 class="font-size-14 mb-0">Uso Fora de Horário</h5>
                  </div>
                  <div class="text-center p-1 border">
                    <h4>{{dadosOcorrencia.foraHorario}}</h4>
                  </div>
                </div>

                <div class="div-clickable col-md-6 m-auto my-1">
                  <div class="bg-info bg-soft text-center p-3">
                    <h5 class="font-size-14 mb-0">Uso na Madrugada</h5>
                  </div>
                  <div class="text-center p-1 border">
                    <h4>{{dadosOcorrencia.madrugada}}</h4>
                  </div>
                </div>

                <div class="div-clickable col-md-6 m-auto my-1">
                  <div class="bg-info bg-soft text-center p-3">
                    <h5 class="font-size-14 mb-0">Condução de Risco</h5>
                  </div>
                  <div class="text-center p-1 border">
                    <h4>{{dadosOcorrencia.risco}}</h4>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card> -->

    <formDespesa
      ref="modal"
      :arrayDados="despesas"
      v-on:trocaTituloModal="trocaTituloModal"
      :desativa="disabledAcoesModal"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import formDespesa from "@/components/despesas/formularioDespesa";
import { required } from "vuelidate/lib/validators";
import { radialChart, pieChart } from "./data-apex.js";

export default {
  components: {
    PageHeader,
    Multiselect,
    formDespesa,
  },
  data() {
    return {
      tooltipTable: {
        ex: false,
        fh: false,
        ma: false,
        ri: false,
      },
      acao: "",
      title: "Acompanhamento | RDV (Relatório de Despesas de Viagem)",
      items: [
        {
          text: "RDV",
        },
        {
          text: "Acompanhamento",
        },
      ],
      graficoDespesa: {},
      graficoCategoria: {},
      viewPieChart: false,
      viewGuageChart: false,
      viewInfoCoop: false,
      viewTabelaDespesas: false,
      viewAprimora: false,
      viewTelemetria: false,
      radialChart: radialChart,
      dados: {
        contrato: null,
        matriz: null,
        projeto: null,
        cooperado: null,
        referencia: null,
      },
      optionContrato: [],
      optionProjeto: [],
      optionCooperado: [],
      objetoContrato: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 30,
      filtro: "",
      filterOn: [],
      despesas: [],
      toastCount: 0,
      campos: [
        {
          key: "icone",
          label: "",
        },
        {
          key: "ds_norma",
          label: "Despesa",
          sortable: true,
        },
        {
          key: "cidade_uf_movimento",
          label: "Cidade",
        },
        {
          key: "dt_lancamento",
          label: "Data",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
          sortable: true,
        },
        {
          key: "vl_lancamento",
          label: "Valor Aprov.",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          class: "alinharCelulaDireita",
          sortable: true,
        },
        {
          key: "vl_original",
          label: "Valor Original",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          class: "alinharCelulaDireita",
          sortable: true,
        },
        {
          key: "ds_st_lancamento",
          label: "Status",
        },
      ],
      dadosInfoCoop: {
        coopNome: "",
        coopCargo: "",
        coopDescCargo: "",
        contrato: "",
        projeto: "",
        sede: "",
        periodo: "",
        fotoCoop: "",
        idade: 0,
        tempoCnh: 0,
      },
      dadosGaugeChart: {
        despesas: 0,
        limite: 0,
        dt_referencia: "",
        dt_inicio: "",
        dt_fim: "",
        status_rdv: "LIBERADO",
      },
      dadosOcorrencia: {},
      loading: false,
      showModal: false,
      dadosModal: {
        identificador: 0,
        listaDeDados: [],
        norma: "",
        status: "Liberado",
        icone: "",
        corIcone: "",
      },
      submit: false,
      dadosTelemetria: [],
      telemetriaDiaria: [],
      mapaCalor: null,
      mapaCalendario: "",
      tabelaTelemetria: [],
      camposTelemetria: [
        {
          key: "data",
          label: "Data",
        },
        {
          key: "excesso",
          label: "EV",
          class: "alinharCelula",
        },
        {
          key: "foraHorario",
          label: "FH",
          class: "alinharCelula",
        },
        {
          key: "madrugada",
          label: "MA",
          class: "alinharCelula",
        },
        {
          key: "risco",
          label: "CV",
          class: "alinharCelula",
        },
        {
          key: "informativo",
          label: "IN",
          class: "alinharCelula",
        },
      ],
      currentPageTelemetria: 1,
      rowsTelemetria: 0,
      diaMapa: "",
      kmDiario: 0,
      directionsAux: [],
      markerOcorrencias: [],
      markerSede: null,
      tabelaAprimora: [],
      camposAprimora: [
        {
          key: "dtconclusao",
          label: "Data",
        },
        {
          key: "dsatividade",
          label: "Atividade",
        },
        {
          key: "nmfantasiaclienterural",
          label: "Cliente",
        },
        {
          key: "tipo",
          label: "Tipo",
        },
      ],
      tabelaAprimoraAux: [],
      currentPageAprimora: 1,
      rowsAprimora: 0,
      syncTelemetria: false,
      rdvStatusGlobal: null,
      disabledSyncTelemetria: true,
      disabledAcoesModal: false,
    };
  },
  validations: {
    dados: {
      referencia: {
        required,
      },
      cooperado: {
        required,
      },
      contrato: {
        required,
      },
      projeto: {
        required,
      },
    },
  },
  created() {
    this.montarMapa();
    this.$store
      .dispatch("filtroTomador", this.$store.state.filtroTomador)
      .then((response) => {
        this.optionContrato =
          this.$tools.filtroTomador.selectContratos(response);
        if (this.$store.state.filtroRdv) {
          var filtro = this.$store.state.filtroRdv;
          this.dados.referencia = filtro.mes + "/" + filtro.ano;
          this.dados.contrato = filtro.contrato;
          this.dados.projeto = filtro.projeto;
          this.dados.matriz = filtro.matriz;
          this.dados.cooperado = filtro.cooperado;
          this.$store.commit("FILTRO_OPERACAO", null);
          this.inputContrato(false);
          this.inputProjeto(false);
          this.filtrar();
        }
      });
    window.calcularKmWin = (el) => {
      this.calcularKm(el);
    };
  },

  computed: {
    rows() {
      return this.despesas.length;
    },
  },
  methods: {
    async montarMapa() {
      try {
        this.google = await this.$gmaps();
        this.map = new this.google.maps.Map(document.getElementById("map"), {
          center: { lat: -23.469806037053726, lng: -51.81222191718324 },
          zoom: 8,
        });
      } catch (error) {
        console.error(error);
      }
    },
    state(param) {
      if (this.submit) {
        return !this.$v.dados[param].$invalid;
      } else {
        return null;
      }
    },
    inputContrato(param = true) {
      if (param) {
        this.optionProjeto = [];
        this.optionCooperado = [];
        this.dados.projeto = null;
        this.dados.cooperado = null;
        this.dados.matriz = this.dados.contrato.matriz;
      }
      this.optionProjeto = this.$tools.filtroTomador.selectProjetos(
        this.$store.state.filtroTomador,
        this.dados.contrato.numero
      );
    },
    inputProjeto(param = true) {
      if (param) {
        this.optionCooperado = [];
        this.dados.cooperado = null;
      }
      this.optionCooperado = this.$tools.filtroTomador.selectCooperados(
        this.$store.state.filtroTomador,
        this.dados.projeto.numero
      );
    },
    filtrar() {
      this.submit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      this.viewPieChart = false;
      this.viewTabelaDespesas = false;
      this.viewGuageChart = false;
      this.viewInfoCoop = false;
      this.viewTelemetria = false;
      this.viewAprimora = false;
      this.limparMapa();
      this.$http
        .post("api/rdvTomador/buscarRdv", {
          cd_matriz: this.dados.matriz,
          cd_cooperado: this.dados.cooperado.numero,
          referencia: this.dados.referencia,
          sq_contrato: this.dados.contrato.numero,
          cd_projeto: this.dados.projeto.numero,
        })
        .then((response) => {
          if (response.data.length == 0) {
            this.$tools.alerta("Nenhuma Despesa", "error");
            this.loading = false;
            return;
          }
          this.despesas = response.data;
          response.data.forEach((el, key) => {
            this.despesas[key].identificador = key;
          });
          this.atribuiInfoCoop(response.data);
          this.atribuiGaugeChart(response.data);
          this.montandoGraficoDespesa(response.data);
          this.montandoGraficoCategoria(response.data[0].cd_rdv);
          this.$tools.fecharMenu();
          // this.filtrarAprimora();
          //this.filtrarTelemetria();
          this.rdvStatusGlobal = response.data[0].st_rdv;
          this.bloqueiaAcoesModal(this.rdvStatusGlobal);
          this.viewTabelaDespesas = true;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$tools.alerta("Erro ao buscar informaçoes do RDV", "error");
          this.loading = false;
        });
    },
    atribuiInfoCoop(response) {

      const calcularIdade = (dataNascimento) => {
        const hoje = new Date();
        const nascimento = new Date(dataNascimento);
        let idade = hoje.getFullYear() - nascimento.getFullYear();
        const mes = hoje.getMonth() - nascimento.getMonth();
        if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
          idade--;
        }
        return idade;
      };

      const calcularTempoCNH = (dataCNH) => {
        const hoje = new Date();
        const cnh = new Date(dataCNH);
        let tempo = hoje.getFullYear() - cnh.getFullYear();
        const mes = hoje.getMonth() - cnh.getMonth();
        if (mes < 0 || (mes === 0 && hoje.getDate() < cnh.getDate())) {
          tempo--;
        }
        return tempo;
      };

      (this.dadosInfoCoop.coopNome =
        response[0].nm_cooperado + " [" + response[0].cd_cooperado + "]"),
        (this.dadosInfoCoop.coopCargo = response[0].ds_cargo),
        (this.dadosInfoCoop.coopProfissao =
          response[0].nm_profissao + " [" + response[0].cd_profissao + "]"),
        (this.dadosInfoCoop.contrato =
          response[0].nr_contrato + " [" + response[0].sq_contrato + "]"),
        (this.dadosInfoCoop.projeto =
          response[0].nm_projeto + " [" + response[0].cd_projeto + "]"),
        (this.dadosInfoCoop.sede = response[0].ds_regiao_coop);
        this.dadosInfoCoop.idade = calcularIdade(response[0].dt_nasc);
        this.dadosInfoCoop.tempo_cnh = calcularTempoCNH(response[0].dt_prim_cnh);
      var dt_inicio = this.$tools
        .converteData(response[0].dt_inicio_coop)
        .substr(0, 10);
      var dt_fim = this.$tools
        .converteData(response[0].dt_final_coop)
        .substr(0, 10);
      (this.dadosInfoCoop.periodo = dt_inicio + " A " + dt_fim),
        (this.dadosInfoCoop.fotoCoop = "");
      if (response[0].ge_pes_fis.nm_caminho_foto) {
        this.dadosInfoCoop.fotoCoop =
          this.$caminhoFotoPerfil + response[0].ge_pes_fis.nm_caminho_foto;
      }
      this.viewInfoCoop = true;
    },
    atribuiGaugeChart(response) {
      this.dadosGaugeChart.limite = response[0].vl_limite_global_rdv;
      this.dadosGaugeChart.cd_rdv = response[0].ge_rdv_iag.cd_rdv;
      this.dadosGaugeChart.dt_referencia = this.$tools.converteData(
        response[0].ge_rdv_iag.dt_referencia.substr(-20, 7)
      );
      this.dadosGaugeChart.dt_inicio = this.$tools.converteData(
        response[0].ge_rdv_iag.dt_inicio
      );
      this.dadosGaugeChart.dt_fim = this.$tools.converteData(
        response[0].ge_rdv_iag.dt_fim
      );
      this.dadosGaugeChart.status_rdv = response[0].status_rdv;
      this.viewGuageChart = true;
      this.somaDespesas();
    },
    somaDespesas() {
      this.dadosGaugeChart.despesas = 0;
      this.despesas.forEach((el) => {
        this.dadosGaugeChart.despesas += parseFloat(el.vl_lancamento);
      });
      var porcentagem = 0;

      if (this.dadosGaugeChart.limite > 0) {
        porcentagem =
          ((this.dadosGaugeChart.limite - this.dadosGaugeChart.despesas) /
            this.dadosGaugeChart.limite) *
          100;
      }

      this.radialChart = radialChart(porcentagem);
      return;
    },
    montandoGraficoDespesa(retorno) {
      var aux = [];
      var nomeDespesa = [];
      retorno.forEach((el) => {
        if (!aux.includes(el.cd_norma)) {
          aux.push(el.cd_norma);
          nomeDespesa[aux.indexOf(el.cd_norma)] = {
            nome: el.ds_norma,
            valor: parseFloat(el.vl_original),
          };
        } else {
          nomeDespesa[aux.indexOf(el.cd_norma)].valor += parseFloat(
            el.vl_original
          );
        }
      });
      nomeDespesa.forEach((el, key) => {
        nomeDespesa[key].valor = parseFloat(nomeDespesa[key].valor.toFixed(2));
        console.log(nomeDespesa[key].valor);
      });
      nomeDespesa = nomeDespesa.sort((a, b) => {
        if (a.valor < b.valor) {
          return 1;
        } else {
          return -1;
        }
      });
      this.graficoDespesa = pieChart(nomeDespesa);
      this.viewPieChart = true;
    },
    montandoGraficoCategoria(cdRdv) {
      var aux = [];
      var dadosPieChartCategoria = [];

      this.$http
        .get("api/rdvCooperado/buscarDespesasCategoria/" + cdRdv)
        .then((response) => {
          response.data.forEach((el) => {
            if (!aux.includes(el.ds_categoria_norma)) {
              aux.push(el.ds_categoria_norma);
              dadosPieChartCategoria[aux.indexOf(el.ds_categoria_norma)] = {
                nome: el.ds_categoria_norma,
                valor: parseFloat(el.total),
              };
            } else {
              dadosPieChartCategoria[aux.indexOf(el.ds_categoria_norma)].valor += parseFloat(el.total);
            }
          });
          
          dadosPieChartCategoria.forEach((el, key) => {
            dadosPieChartCategoria[key].valor = parseFloat(dadosPieChartCategoria[key].valor.toFixed(2));
          });

          dadosPieChartCategoria = dadosPieChartCategoria.sort((a, b) => {
            if (a.valor < b.valor) {
              return 1;
            } else {
              return -1;
            }
          });
          this.graficoCategoria = pieChart(dadosPieChartCategoria);
          this.viewPieChart = true;
          
          // Seleciona todos os elementos <li> com role="presentation" que contêm um <a> dentro
          const liElements = document.querySelectorAll('li[role="presentation"].nav-item');

          // Itera sobre cada <li> e aplica a borda ao <a> dentro dele
          liElements.forEach((li) => {
            const link = li.querySelector('a');
            if (link) {
              link.style.border = "1px solid #ccc";
            }
          });
        });
    },
    abrirModal(items) {
      this.$refs.modal.abrirModal(items.identificador);
      this.bloqueiaAcoesModal(this.rdvStatusGlobal, items.st_lancamento);
      this.showModal = true;
    },
    trocaTituloModal(norma, situacao, icone, corIcone, st_lancamento) {
      this.dadosModal.norma = norma;
      this.dadosModal.status = situacao;
      this.dadosModal.icone = icone;
      this.dadosModal.corIcone = corIcone;
      this.bloqueiaAcoesModal(this.rdvStatusGlobal, st_lancamento);
    },
    limpar() {
      this.dados.referencia = "";
      this.dados.contrato = "";
      this.dados.projeto = "";
      this.dados.cooperado = "";
      (this.viewPieChart = false),
        (this.viewGuageChart = false),
        (this.viewInfoCoop = false),
        (this.tableGastos = false);
    },
    filtrarTelemetria() {
      this.montarMapa();
      this.diaMapa = "";
      this.kmDiario = 0;
      this.$http
        .post("api/telemetria", {
          referenciaInicio: this.despesas[0].ge_rdv_iag.dt_inicio,
          referenciaFim: this.despesas[0].ge_rdv_iag.dt_fim,
          cooperado: this.dados.cooperado.numero,
          cd_projeto: this.dados.projeto.numero,
        })
        .then((response) => {
          this.dadosTelemetria = response.data;
          if (this.dadosTelemetria.length > 0) {
            this.criarInformacoesDiaria();
            this.marcarSede();
          } else {
            // this.$tools.alerta("Nenhuma informação encontrada com esses parametros", "error");
            this.loading = false;
          }
        })
        .catch(() => {
          this.$tools.alerta(
            "Erro ao buscar informaçoes da telemetria",
            "error"
          );
        });
    },
    criarInformacoesDiaria() {
      var dataGps = [];
      var index = 0;
      var indexDados = 0;
      this.dadosInfoCoop.idade = this.dadosTelemetria[0].idade;
      this.dadosInfoCoop.tempo_cnh = this.dadosTelemetria[0].tempo_cnh;
      this.dadosOcorrencia = {
        excesso: 0,
        foraHorario: 0,
        madrugada: 0,
        risco: 0,
      };
      this.telemetriaDiaria = [];
      this.mapaCalendario = new Date(this.dadosTelemetria[0].dt_gps);
      this.dadosTelemetria.forEach((el) => {
        if (!dataGps.includes(el.data)) {
          index = dataGps.push(el.data);
          index--;

          this.telemetriaDiaria[index] = {
            data: el.data,
            dt_gps: new Date(el.dt_gps),
            dados: [],
            excesso: 0,
            foraHorario: 0,
            madrugada: 0,
            risco: 0,
            informativo: 0,
            mapaIndex: index,
            _cellVariants: {},
          };

          indexDados = this.telemetriaDiaria[index].dados.push(el);
          indexDados--;
          this.separarOcorrencias(el, index, indexDados);
        } else {
          indexDados = this.telemetriaDiaria[dataGps.length - 1].dados.push(el);
          indexDados--;
          this.separarOcorrencias(el, index, indexDados);
        }
      });
      this.viewTelemetria = true;
      this.rowsTelemetria = this.telemetriaDiaria.length;
      this.tabelaTelemetria = this.telemetriaDiaria;
      this.telemetriaDiaria.forEach((el) => {
        this.dadosOcorrencia.excesso += el.excesso;
        this.dadosOcorrencia.foraHorario += el.foraHorario;
        this.dadosOcorrencia.madrugada += el.madrugada;
        this.dadosOcorrencia.risco += el.risco;
      });
    },
    separarOcorrencias(param, index, indexDados) {
      switch (param.tp_posicao) {
        case "E":
          this.telemetriaDiaria[index].excesso++;
          this.telemetriaDiaria[index].dados[indexDados].icon =
            this.$iconOcorrencia + "excesso.png";
          this.telemetriaDiaria[index]._cellVariants.excesso = "warning";
          break;
        case "F":
          this.telemetriaDiaria[index].foraHorario++;
          this.telemetriaDiaria[index].dados[indexDados].icon =
            this.$iconOcorrencia + "foraHorario.png";
          this.telemetriaDiaria[index]._cellVariants.foraHorario = "secondary";
          break;
        case "M":
          this.telemetriaDiaria[index].madrugada++;
          this.telemetriaDiaria[index].dados[indexDados].icon =
            this.$iconOcorrencia + "madrugada.png";
          this.telemetriaDiaria[index]._cellVariants.madrugada = "primary";
          break;
        case "R":
          this.telemetriaDiaria[index].risco++;
          this.telemetriaDiaria[index].dados[indexDados].icon =
            this.$iconOcorrencia + "risco.png";
          this.telemetriaDiaria[index]._cellVariants.risco = "danger";
          break;
        default:
          this.telemetriaDiaria[index].informativo++;
          this.telemetriaDiaria[index].dados[indexDados].icon =
            this.$iconOcorrencia + "informativo.png";
          break;
      }
    },
    montarMapaDirecoes(param) {
      this.limparMapa();
      this.diaMapa = param.data;
      this.kmDiario = 0;
      var arrayWayPoints = [];
      var matrizWayPoint = [];
      var i = 1;
      var arrayLocation = [];

      arrayLocation.push(param.dados[0]);
      arrayLocation.push(param.dados[param.dados.length - 1]);
      param.dados.forEach((el, key, list) => {
        if (list[key - 1]) {
          if (
            el.ds_localizacao != list[key - 1].ds_localizacao ||
            el.ds_localizacao == null
          ) {
            arrayLocation.push(el);
          }
        }
      });

      arrayLocation.forEach((el) => {
        if (i % 24 == 0 || i == arrayLocation.length) {
          matrizWayPoint.push(arrayWayPoints);
          arrayWayPoints = [];
          arrayWayPoints.push({
            location: {
              lat: parseFloat(el.nr_latitude),
              lng: parseFloat(el.nr_longitude),
            },
          });
        } else {
          arrayWayPoints.push({
            location: {
              lat: parseFloat(el.nr_latitude),
              lng: parseFloat(el.nr_longitude),
            },
          });
        }
        i++;
      });

      matrizWayPoint.forEach((el) => {
        this.directionsAux.push(this.marcarDirecao(el));
      });

      this.disabledSyncTelemetria = false;
      // this.sincronizaAprimoraTelemetria();
      this.adicionarMarcadores(param.dados);
    },
    marcarDirecao(param) {
      var originAux = param[0].location;
      var destinationAux = param[param.length - 1].location;
      var directionsService = new this.google.maps.DirectionsService();
      var directionsRenderer = new this.google.maps.DirectionsRenderer({
        preserveViewport: false,
        suppressMarkers: true,
        polylineOptions: {
          strokeColor: "green",
          strokeOpacity: 0.5,
          strokeWeight: 7,
        },
      });
      directionsRenderer.setMap(this.map);

      var request = {
        origin: originAux,
        destination: destinationAux,
        waypoints: param,
        travelMode: "DRIVING",
      };

      directionsService.route(request, function (result, status) {
        if (status == "OK") {
          directionsRenderer.setDirections(result);
          window.calcularKmWin(result);
        }
      });

      return directionsRenderer;
    },
    calcularKm(param) {
      param.routes[0].legs.forEach((el) => {
        this.kmDiario += el.distance.value;
      });
    },
    adicionarMarcadores(param) {
      var icon = {};
      param.forEach((el, key) => {
        if (key === 0) {
          //Define icone de destino
          icon = {
            url: this.$iconOcorrencia + "origem.png",
            scaledSize: new this.google.maps.Size(30, 30),
          };
        } else if (key === param.length - 1) {
          //Define icone de origem
          icon = {
            url: this.$iconOcorrencia + "dest.png",
            scaledSize: new this.google.maps.Size(30, 30),
          };
        } else {
          icon = el.icon;
        }
        this.markerOcorrencias.push({
          marker: new this.google.maps.Marker({
            map: this.map,
            position: {
              lat: parseFloat(el.nr_latitude),
              lng: parseFloat(el.nr_longitude),
            },
            icon: icon,
          }),
          info: el,
        });
      });

      var popup = "";
      this.markerOcorrencias.forEach((el) => {
        popup =
          "Data: " +
          el.info.data +
          " " +
          el.info.hora +
          " " +
          this.$tools.diaSemanaAbrev(new Date(el.info.dt_gps).getDay()); //Hora
        popup += el.info.nr_placa ? "<br>Placa: " + el.info.nr_placa : ""; //Placa
        popup += el.info.veiculo ? "<br>Veiculo: " + el.info.veiculo : ""; //Veiculo
        popup += el.info.rastreador
          ? "<br>Rastreador: " + el.info.rastreador
          : ""; //Rastreador
        popup += "<br>Ocorrência: " + this.siglaOcorrencia(el.info.tp_posicao); //Ocorrência
        popup += el.info.nr_velocidade
          ? "<br>Velocidade: " + el.info.nr_velocidade + " Km/H"
          : ""; //Velocidade
        popup += el.info.ds_localizacao
          ? "<br>Localidade: " + el.info.ds_localizacao
          : ""; //Descricao
        popup +=
          "<br>Cidade-UF: " +
          el.info.ge_regiao.nm_regiao +
          " - " +
          el.info.ge_regiao.ds_uf; //Regiao

        var infowindow = new this.google.maps.InfoWindow({
          content: popup,
        });
        el.marker.addListener("click", () => {
          infowindow.open({
            anchor: el.marker,
            map: this.map,
            shouldFocus: false,
          });
        });
      });
    },
    marcarSede() {
      if (this.markerSede) {
        this.markerSede.setMap(null);
      }
      this.markerSede = new this.google.maps.Marker({
        map: this.map,
        position: {
          lat: parseFloat(this.despesas[0].nr_latitude_sede),
          lng: parseFloat(this.despesas[0].nr_longitude_sede),
        },
        icon: {
          url: this.$iconOcorrencia + "sede.png",
          scaledSize: new this.google.maps.Size(30, 30),
        },
      });
      this.map.setCenter({
        lat: parseFloat(this.despesas[0].nr_latitude_sede),
        lng: parseFloat(this.despesas[0].nr_longitude_sede),
      });

      var infowindow = new this.google.maps.InfoWindow({
        content: "Cidade Sede: " + this.dadosInfoCoop.sede,
      });
      this.markerSede.addListener("click", () => {
        infowindow.open({
          anchor: this.markerSede,
          map: this.map,
          shouldFocus: false,
        });
      });
    },
    filtrarAprimora() {
      this.$http
        .post("api/aprimora", {
          referenciaInicio: this.despesas[0].ge_rdv_iag.dt_inicio,
          referenciaFim: this.despesas[0].ge_rdv_iag.dt_fim,
          cooperado: this.dados.cooperado.numero,
          cd_projeto: this.dados.projeto.numero,
          sq_contrato: this.dados.contrato.numero,
        })
        .then((response) => {
          if (response.data.length > 0) {
            this.tabelaAprimoraAux = response.data;
            this.tabelaAprimora = this.tabelaAprimoraAux;
            this.viewAprimora = true;
            this.rowsAprimora = this.tabelaAprimora.length;
          } else {
            // this.$tools.alerta("Nenhuma informação de aprimora encontrada", "error");
            this.loading = false;
            this.viewAprimora = false;
            this.rowsAprimora = 0;
          }
        })
        .catch(() => {
          this.$tools.alerta("Erro ao buscar informaçoes do aprimora", "error");
          this.viewAprimora = false;
          this.rowsAprimora = 0;
        });
    },
    emitirRelatorioAprimora(dadosAprimora) {
      var atividade = {
        Aplicação: "Aplicacao",
        Avaliação: "Avaliacao",
        Colheita: "Colheita",
        Evento: "Evento",
        "Geração de Demanda": "GeracaodeDemanda",
        Plantio: "Plantio",
        Visita: "Visita",
      };
      var url = "https://uniweb2.unicampo.coop.br/Relatorios/Relatorio/";
      url += atividade[dadosAprimora.tipo]
        ? atividade[dadosAprimora.tipo]
        : "Visita";
      url += "/" + dadosAprimora.cdpessoa;
      url += "/" + dadosAprimora.sqformulario;
      url += "/" + dadosAprimora.sys_usuario.sq_usuario;
      url += "/" + (Math.floor(Math.random() * 1000) + 1000);
      window.open(url);
    },
    limparMapa() {
      if (this.directionsAux) {
        this.directionsAux.forEach((el) => {
          el.setMap(null);
        });
        this.markerOcorrencias.forEach((el) => {
          el.marker.setMap(null);
        });
        this.directionsAux = [];
        this.markerOcorrencias = [];
      }
    },
    siglaOcorrencia(sigla) {
      switch (sigla) {
        case "E":
          return "Excesso de velocidade";
        case "F":
          return "Uso fora de horário";
        case "M":
          return "Uso na madrugada";
        case "R":
          return "Condução de Risco";
        default:
          return "Informativo";
      }
    },
    sincronizaAprimoraTelemetria() {
      if (this.syncTelemetria) {
        this.tabelaAprimora = this.tabelaAprimoraAux.filter((el) => {
          if (this.$tools.converteData(el.dtconclusao) !== this.diaMapa) {
            return false;
          }
          return true;
        });
      } else {
        this.tabelaAprimora = this.tabelaAprimoraAux;
      }
      this.rowsAprimora = this.tabelaAprimora.length;
    },
    bloqueiaAcoesModal(st_rdv, st_lancamento) {
      if (
        st_rdv === "E" ||
        st_rdv === "B" ||
        st_rdv === "L" ||
        st_rdv === "P" ||
        st_lancamento === "A" ||
        st_lancamento === "B" ||
        st_lancamento === "L" ||
        st_lancamento === "R"
      ) {
        this.disabledAcoesModal = true;
        return;
      }
      this.disabledAcoesModal = false;
    },
  },
};
</script>
<style scoped>
.apexMargin {
  margin-top: -5% !important;
}
.fundoAcao {
  background-color: gainsboro;
}
.custom-border .nav-pills .nav-link {
  border: 1px solid #ccc !important;
}
</style>